<img class="icon"
     [src]="scanAnimation"/>
<div class="message"
     [class.focused]="focused"
     [class.blurred]="!focused">
    {{ scanMessage }}
</div>
